module.exports = __webpack_public_path__ + "static/media/Paresh Daya Profile Pic.049463fd.png";